export default __webpack_public_path__ + "static/media/screen9.07c4b140.png";